/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_FieldInputs */

const fr_validation_field = /** @type {(inputs: Validation_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez ce champ.`)
};

const en_validation_field = /** @type {(inputs: Validation_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check this field.`)
};

/**
* | output |
* | --- |
* | "Check this field." |
*
* @param {Validation_FieldInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_field = /** @type {((inputs?: Validation_FieldInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_FieldInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_field(inputs)
	return fr_validation_field(inputs)
});